import React from "react";
import { Result } from "antd";

const NotFound = () => {

    return (
        <div className="h-100 w-100 d-flex justify-content-center align-items-center">
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
            />
        </div>
    );
};

export default NotFound;
